export const soQuy = {
  sections: {
    phieuThuList: { title: '收款单' },
    phieuThuDetail: { title: '收款单详情' },
    phieuChiList: { title: '付款单' },
    phieuChiDetail: { title: '付款单详情' },
    soQuyList: { title: '现金账' },
    baoCao: { title: '现金账报表' },
    taiKhoanQuy: { title: '资金账户' },
  },
  menu: {
    group: '现金账',
    phieuThu: '收款单',
    phieuChi: '付款单',
    soQuy: '现金账',
    baoCao: '报表',
  },
  phieuThu: {
    title: '收款单',
    list: '收款单列表',
    create: '新建收款单',
    update: '编辑收款单',
    detail: '收款单详情',
    hintMaPhieu: '保存时自动生成单号。',
    sectionTitles: {
      thongTinPhieu: '单据信息',
      thongTinDoiTuong: '对方信息',
      thongTinTaiKhoan: '账户信息',
      thongTinThanhToan: '付款信息',
      noiDungGhiChu: '内容与备注',
    },
    fields: {
      maPhieu: '单号',
      thoiGian: '时间',
      loaiThuChi: '收付款类型',
      doiTuong: '对方',
      doiTuongTen: '对方名称',
      doiTuongLoai: '对方类型',
      taiKhoanQuy: '资金账户',
      soTien: '金额',
      noiDung: '内容',
      ghiChu: '备注',
      trangThai: '状态',
      nguoiTao: '创建人',
      nguoiDuyet: '审批人',
      thoiGianTao: '创建时间',
      thoiGianCapNhat: '更新时间',
      thoiGianDuyet: '审批时间',
      lyDoTuChoi: '拒绝原因',
      lyDoHuy: '取消原因',
      chungTuDinhKem: '附件',
      doiTuongSdt: '对方电话',
      doiTuongDiaChi: '对方地址',
      soDuTaiThoiDiem: '当时余额',
    },
  },
  phieuChi: {
    title: '付款单',
    list: '付款单列表',
    create: '新建付款单',
    update: '编辑付款单',
    detail: '付款单详情',
    hintMaPhieu: '保存时自动生成单号。',
    sectionTitles: {
      thongTinPhieu: '单据信息',
      thongTinDoiTuong: '对方信息',
      thongTinTaiKhoan: '账户信息',
      thongTinThanhToan: '付款信息',
      noiDungGhiChu: '内容与备注',
    },
    fields: {
      maPhieu: '单号',
      thoiGian: '时间',
      loaiThuChi: '收付款类型',
      doiTuong: '对方',
      doiTuongTen: '对方名称',
      doiTuongLoai: '对方类型',
      taiKhoanQuy: '资金账户',
      soTien: '金额',
      noiDung: '内容',
      ghiChu: '备注',
      trangThai: '状态',
      nguoiTao: '创建人',
      nguoiDuyet: '审批人',
      thoiGianTao: '创建时间',
      thoiGianCapNhat: '更新时间',
      thoiGianDuyet: '审批时间',
      lyDoTuChoi: '拒绝原因',
      lyDoHuy: '取消原因',
      chungTuDinhKem: '附件',
      doiTuongSdt: '对方电话',
      doiTuongDiaChi: '对方地址',
      soDuTaiThoiDiem: '当时余额',
    },
  },
  // Story 3.3 — Unified cash book page (FR-10). 现金账总览页。
  // i18n key structure mirrors `phieuThu` / `phieuChi`.
  unified: {
    title: '现金账总览',
    list: '现金账总览',
    tabs: {
      all: '全部',
      thu: '收款单',
      chi: '付款单',
    },
    fields: {
      loai: '类型',
      loaiThuChi: '收付款类型',
    },
    summary: {
      title: '总收入 / 总支出 / 累计(全部筛选 — 已审批)',
      tongThu: '总收入',
      tongChi: '总支出',
      chenhLech: '累计',
    },
  },
  trangThai: {
    NHAP: '草稿',
    CHO_DUYET: '待审批',
    DA_DUYET: '已审批',
    HUY: '已取消',
  },
  loai: { THU: '收款', CHI: '付款' },
  loaiTaiKhoan: {
    TIEN_MAT: '现金',
    NGAN_HANG: '银行账户',
  },
  doiTuongLoai: {
    KHACH_HANG: '客户',
    NHA_CUNG_CAP: '供应商',
    NGUOI_DUNG: '员工',
    TU_DO: '其他',
  },
  actions: {
    luu: '保存草稿',
    luuThayDoi: '保存更改',
    dong: '关闭',
    quayLai: '返回列表',
    taoPhieuThu: '新建收款单',
    taoPhieuChi: '新建付款单',
    sua: '编辑',
    guiDuyet: '提交审批',
    duyet: '审批',
    tuChoi: '拒绝',
    huy: '取消',
    xoa: '删除',
    in: '打印',
    xuatExcel: '导出 Excel',
    xem: '查看',
    taiLai: '刷新',
    datLaiBoLoc: '重置筛选',
  },
  messages: {
    banner: {
      choDuyet: '凭证待审批。',
      daDuyet: '凭证已由 {nguoiDuyet} 于 {thoiGian} 审批。',
      huy: '凭证已取消。原因:{lyDo}。',
    },
    taoThanhCong: '已创建收款单 {maPhieu}。',
    suaThanhCong: '已更新收款单 {maPhieu}。',
    guiDuyetThanhCong: '已提交收款单 {maPhieu} 审批。',
    duyetThanhCong: '已审批收款单 {maPhieu}。',
    tuChoiThanhCong: '已拒绝收款单 {maPhieu}。',
    huyThanhCong: '已取消收款单 {maPhieu}。',
    loadError: '无法加载收款单列表。',
    loadErrorChi: '无法加载付款单列表。',
    chiTietLoadError: '无法加载收款单详情。',
    auditLoadError: '无法加载操作历史。',
    notFound: '未找到收款单。',
    khongCoQuyen: '您没有执行此操作的权限。',
    xungDotVersion: '收款单已被其他人修改,请重新加载。',
    loiHeThong: '系统错误,请稍后重试。(错误代码:{code})',
    chuaCoPhieu: '暂无收款单。',
    chuaCoPhieuChi: '暂无付款单。',
    chuaCoPhieuKhopLoc: '没有符合筛选条件的收款单。',
    chuaCoPhieuKhopLocChi: '没有符合筛选条件的付款单。',
    // Story 3.3 — 总览页空状态。
    chuaCoPhieuUnified: '现金账中暂无单据。',
    chuaCoTaiKhoanQuy: '暂无资金账户,请联系超级管理员。',
    dangPhatTrien: '页面开发中({story})。',
    canhBaoSoDuAm: '付款后余额: {soDuSauKhiChi} (负数)。仍可创建凭证,主管审批时会考虑。',
    guiDuyetThanhCongChi: '已提交付款单 {maPhieu} 审批。',
    duyetThanhCongChi: '已审批付款单 {maPhieu}。',
    tuChoiThanhCongChi: '已拒绝付款单 {maPhieu}。',
    huyThanhCongChi: '已取消付款单 {maPhieu}。',
    xoaThanhCong: '已删除收款单草稿 {maPhieu}。',
    xoaThanhCongChi: '已删除付款单草稿 {maPhieu}。',
    taoThanhCongChi: '已创建付款单 {maPhieu}。',
    suaThanhCongChi: '已更新付款单 {maPhieu}。',
    xacNhan: {
      guiDuyet: '提交审批收款单 {maPhieu}?',
      guiDuyetChi: '提交审批付款单 {maPhieu}?',
      duyet: '审批收款单 {maPhieu}?{taiKhoanQuy} 余额将增加 +{soTien}。',
      duyetChi: '审批凭证 {maPhieu}?{taiKhoanQuy} 余额将减少 -{soTien}。',
      duyetChiKhongDuQuy: '{taiKhoanQuy} 余额仅剩 {soDu},不足以支付 {soTien}。系统将不允许审批此凭证。',
      tuChoi: '拒绝收款单 {maPhieu}?创建人将收到通知。',
      tuChoiChi: '拒绝付款单 {maPhieu}?创建人将收到通知。',
      huy: '取消已审批收款单 {maPhieu}?余额将减少 -{soTien}。',
      huyChi: '取消已审批付款单 {maPhieu}?余额将退还 +{soTien}。',
      xoa: '删除收款单草稿 {maPhieu}？删除后无法恢复。',
      xoaChi: '删除付款单草稿 {maPhieu}？删除后无法恢复。',
    },
  },
  filters: {
    hintSection: '收款单筛选',
    hintBody: '按状态、时间、资金账户、收付款类型、创建人、对方筛选。',
    trangThai: '状态',
    thoiGian: '时间',
    taiKhoanQuy: '资金账户',
    loaiThuChi: '收付款类型',
    nguoiTao: '创建人',
    doiTuong: '对方',
    chiNhanh: '分支',
    homNay: '今天',
    tuanNay: '本周',
    thangNay: '本月',
    quyNay: '本季度',
    namNay: '今年',
    tuyChinh: '自定义',
    // Story 3.3 —"类型(收款/付款)"筛选侧边栏(仅总览页)。
    loaiAll: '全部',
    loaiThu: '收款单',
    loaiChi: '付款单',
    // Story 3.3 review patch — Section title (resolve i18n tautology).
    loaiThuChiSection: '类型（收款/付款）',
    taiKhoanQuyAll: '全部资金账户',
    taiKhoanQuySearch: '搜索资金账户',
    taiKhoanQuyEmpty: '暂无资金账户',
    dateRangePlaceholder: '选择日期范围',
    loaiThuChiAll: '全部类型',
    loaiThuChiSearch: '搜索收支类型',
    loaiThuChiEmpty: '暂无收支类型',
    nguoiTaoAll: '全部创建人',
    nguoiTaoSearch: '搜索创建人',
    nguoiTaoEmpty: '暂无创建人',
  },
  filter: {
    searchPlaceholder: '按单号、对方、内容搜索...',
    textDetailTitle: '详细筛选',
  },
  validation: {
    soTienRequired: '请输入金额。',
    soTienInvalid: '金额必须大于 0。',
    taiKhoanQuyRequired: '请选择资金账户。',
    thoiGianRequired: '请选择时间。',
    thoiGianFuture: '时间不能晚于今天。',
    noiDungRequired: '请输入内容。',
    doiTuongIdRequired: '请从列表中选择对方。',
    chuaXacDinhChiNhanh: '未确定分支,请联系管理员。',
    lyDoTuChoiRequired: '请输入拒绝原因(10–500 个字符)。',
    lyDoHuyRequired: '请输入取消原因(20–500 个字符)。',
    doiTuongTenRequired: '请输入对方名称(至少 3 个字符)。',
    lyDoMinLength: '至少 {n} 个字符。',
    lyDoMinLengthLabel: '至少 {n} 个字符',
    // Code review 1.10 patches:
    taiDuLieuThatBai: '数据加载失败。请关闭后重新打开表单。',
    noiDungQuaDai: '内容过长(最多 1000 个字符)。',
    ghiChuQuaDai: '备注过长(最多 2000 个字符)。',
  },
  printTemplate: {
    title: '收 款 单',
    titleChi: '付 款 单',
    ngayThangNam: '{nam}年{thang}月{ngay}日',
    soTien: '金额',
    soTienBangChu: '大写金额:{chu}',
    nguoiLap: '制单',
    thuQuy: '出纳',
    nguoiNhan: '收款人',
    keToanTruong: '会计主管',
    giamDoc: '总经理',
    // Story 3.4 — extend print template (FR-13). 29 个新键。
    printButton: '打印凭证',
    closeButton: '关闭',
    printPreviewTitle: '打印预览',
    printLoadingData: '正在加载打印数据...',
    printNotSupported: '浏览器不支持打印。请使用 Chrome/Edge/Firefox。',
    printMobileWarning: '从移动设备打印效果不佳。请使用桌面设备以获得最佳打印质量。',
    printErrorLoad: '无法加载打印数据。请重试。',
    printNotFound: '未找到凭证。凭证可能已被删除或您没有访问权限。',
    printCrossTenant: '您没有打印此凭证的权限(不同分支)。',
    maPhieu: '单号',
    thoiGian: '时间',
    sdt: '电话',
    diaChi: '地址',
    taiKhoanQuy: '账户',
    kemTheo: '附件',
    kemTheoEmpty: '—',
    kyGhiRoHoTen: '(签字,注明姓名)',
    nguoiNop: '付款人',
    hoTenNguoiNop: '付款人姓名',
    hoTenNguoiNhan: '收款人姓名',
    nguoiDuyet: '审批人',
    lyDoThu: '收款原因',
    lyDoChi: '付款原因',
    congTy: '公司',
    chiNhanh: '分支',
    qrLabel: '二维码',
    maPhieuQrLabel: '单号:{maPhieu}',
    qrAriaLabel: '包含单号 {maPhieu} 的二维码,扫码验证',
    empty: '—',
  },
  taiKhoanQuy: {
    title: '资金账户',
    list: '资金账户列表',
    create: '新建资金账户',
    update: '编辑资金账户',
    fields: {
      ma: '账户编码',
      ten: '账户名称',
      loai: '账户类型',
      soDuBanDau: '期初余额',
      soDuHienTai: '当前余额',
      nganHang: '银行',
      soTaiKhoan: '账号',
      chiNhanh: '分支',
      trangThai: '状态',
    },
  },
  audit: {
    title: '操作历史',
    empty: '暂无操作历史。',
    xemTatCa: '查看全部',
    thucHienBoi: '由 {actor} 操作',
    thoiGianKhongHopLe: '--',
    actions: {
      create: '创建单据',
      update: '更新单据',
      submit: '提交审批',
      approve: '已审批',
      reject: '已拒绝',
      cancel: '已取消',
      unknown: '其他',
    },
  },
  // Story 4.3 — 现金账报表页(FR-11 part 1)。
  // 4 张汇总卡(期初余额 / 总收入 / 总支出 / 期末余额)+ 筛选条 + 刷新 / 错误状态。
  baoCao: {
    soDuDauKy: '期初余额',
    tongThu: '总收入',
    tongChi: '总支出',
    soDuCuoiKy: '期末余额',
    sectionTongHop: '期间汇总',
    sectionChiTiet: '明细发生',
    chenhLech: '差额:{soTien}',
    tongCong: '合计',
    breadcrumbSoQuy: '现金账簿',
    subtitle: '跟踪所选期间分支的现金流',
    chiNhanhHint: '当前分支',
    khongCoThuTrongKy: '本期暂无收入。',
    khongCoChiTrongKy: '本期暂无支出。',
    loadErrorTitle: '无法加载现金账报表。',
    refreshSuccess: '报表已刷新。',
    xuatExcelDefer: 'Excel 导出将在下一版本提供(Story 4.5)。',
    // Story 4.5 — tooltip + aria-label cho nút [📥 Xuất Excel].
    xuatExcelInvalidKy: '请选择有效期间',
    xuatExcelAriaLabel: '导出资金账报告到 Excel',
    tu: '从',
    den: '至',
    filterPlaceholder: '按账户名称、账号搜索...',
    filterTenTaiKhoan: '资金账户名称',
    filterSoTaiKhoan: '账号',
  },
  summary: {
    tongThu: '总收入',
    tongChi: '总支出',
    luyKe: '累计',
  },
  labels: {
    lyDo: '理由',
    soDuTaiThoiDiemHint: '资金账户在单据发生时的余额。',
  },
  aria: {
    trangThai: '状态：{label}',
    columnPicker: '选择显示列',
  },
  // Story 4.4 — 收支明细账(FR-11 part 2)。
  bangKe: {
    thuTitle: '收款明细账',
    chiTitle: '付款明细账',
    columns: {
      maPhieu: '单据编号',
      thoiGian: '日期',
      loaiThuChi: '收支类别',
      soTien: '金额',
      nguoiTao: '创建人',
    },
    emptyThu: '本期暂无已审批的收款。',
    emptyChi: '本期暂无已审批的付款。',
    loadError: '无法加载明细账,请重试。',
    refreshSuccess: '明细账已刷新。',
    xemChiTiet: '查看单据详情 {maPhieu}',
    rowsPerPage: '每页行数:',
    // P7 (code review D1): 说明明细账不按资金账户筛选(仅4个汇总卡片筛选)。
    subtitleAllChiNhanh: '全分支明细账(不按所选资金账户筛选)',
  },
  // Story 4.4 — 余额变动图表(FR-11 part 2)。
  bienDong: {
    title: '每日收支变动',
    legendThu: '收入',
    legendChi: '支出',
    legendSoDu: '期末余额',
    empty: '本期暂无变动数据。',
    requireTaiKhoanQuy: '请至少选择 1 个资金账户以查看图表。',
    loadError: '无法加载图表数据,请重试。',
    refreshSuccess: '图表已刷新。',
    mobileSummary: '总收入:{tongThu},总支出:{tongChi}',
  },
  // Story 4.5 — Excel 导出流程(FR-12 wire-up)。
  xuatExcel: {
    dangTaiFile: '正在下载文件...',
    dangTai: '加载中...',
    thanhCong: 'Excel 文件已下载。',
    matKetNoi: '连接中断。请重试。',
    thamSoKhongHopLe: '参数无效。请检查期间。',
    khongCoQuyen: '您没有导出 Excel 的权限。',
    loiHeThong: '导出 Excel 时系统错误。请重试。',
  },
  loaiThuChi: {
    listTitle: '收支类型',
    searchPlaceholder: '按编码或名称搜索...',
    filterLoaiAll: '全部类型',
    filter: {
      textDetailTitle: '详细筛选',
    },
    filterSection: {
      loai: '类型',
      tatCa: '全部',
    },
    empty: '暂无收支类型。',
    listSummary: '共 {count} 个类型',
    fields: {
      ma: '编码',
      loai: '类型',
      ten: '类型名称',
      maHintCreate: '留空将自动生成（如 {example}）',
      maHintEdit: '必须以 {prefix} 开头',
    },
    heThongBadge: '系统',
    actions: { taoMoi: '新建' },
    titles: {
      create: '新建收支类型',
      edit: '编辑收支类型',
      delete: '删除收支类型',
    },
    validation: {
      tenRequired: '请输入类型名称',
      maRequired: '请输入类型编码',
      maInvalid: '编码须为 THUXXX 或 CHIXXX（如 THU001）',
      maLoaiMismatch: '编码必须以 {prefix} 开头',
    },
    messages: {
      loadError: '无法加载收支类型列表。',
      createSuccess: '已创建收支类型。',
      createError: '无法创建收支类型。',
      updateSuccess: '已更新收支类型。',
      updateError: '无法更新收支类型。',
      deleteSuccess: '已删除收支类型。',
      deleteError: '无法删除收支类型。',
      deleteConfirm: '删除收支类型 "{ten}"？',
    },
  },
}
